import { render } from "./InvoicesPage.vue?vue&type=template&id=7512ae77&ts=true"
import script from "./InvoicesPage.vue?vue&type=script&lang=ts"
export * from "./InvoicesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__